export var LegendSymbolType;
(function (LegendSymbolType) {
    LegendSymbolType["Hexagon"] = "Hexagon";
    LegendSymbolType["Square"] = "Square";
})(LegendSymbolType || (LegendSymbolType = {}));
